module.exports = __webpack_public_path__ + "static/media/github-brands.6ea28bf2.svg";